import React from 'react';
import { navigate } from 'gatsby';
import { ShopstoryProvider } from '@shopstory/core/react';
import { Badge } from '@nooz-optics/nooz-components-lib';
import { Body, Button } from '../components/UI/Elements';
import { Label } from '../components/UI/Elements/Label/label';
import { ShopProductItem } from '../components/Ecommerce/Shop';
import { Link } from '../components/UI/Elements/Link';
import { Image } from '../components/UI/Media';
import { useDrawer } from 'utils/recoil/drawer';
import { withLocale } from '../utils/hocs';
import '../styles/global.css';

const SimpleDrawer = (drawer) => ({ image, title, body }) => {
  const bodyProps = {
    richBody: { raw: JSON.stringify(body?.richBody || {}), reference: [] },
  };

  drawer.open({
    placement: 'right',
    title: title,
    actionButton: null,
    width: 'md:w-screen/3 w-screen-95',
    body: (
      <div className='p-4'>
        <div className='relative flex flex-col h-auto'>
          {image ? (
            <div className='h-1/2 overflow-hidden w-full'>
              <Image
                media={{ file: image.fields.file }}
                objectFit='cover'
                width='100%'
              />
            </div>
          ) : null}
          <div className='h-1/2 mt-4 flex flex-col justify-center text-left items-start'>
            {body ? <Body {...bodyProps} /> : null}
          </div>
        </div>
      </div>
    ),
    footer: null,
    backdropLink: null,
  });
};

const SlugLink = (locale) => ({ slug }) => {
  navigate(`/${locale}/${slug.url}`);
};

export const DemoShopstoryProvider = withLocale(({ children, locale }) => {
  const drawer = useDrawer();

  return (
    <ShopstoryProvider
      actions={{
        SimpleDrawer: SimpleDrawer(drawer),
        SlugLink: SlugLink(locale[0]),
      }}
      components={{
        button: Button,
        label: Label,
        shopItem: ShopProductItem,
        badge: Badge,
        badgeIcon: ({ justifyContent, ...props }) => {
          return (
            <div style={{ display: 'flex', justifyContent }}>
              <Badge {...props} />
            </div>
          );
        },
        link: Link,
        image: Image,
      }}
    >
      {children}
    </ShopstoryProvider>
  );
});
